<div class="ir-area ir-mask th-mask" *ngIf="categoriesForm">
  <form class="ir-modal th-modal" (ngSubmit)="save(categoriesForm.value)" [formGroup]="categoriesForm">
    <div class="ir-modal--title">
      <div class="ir-line--right"></div>
      <div class="ir-line">
        <div class="ir-line-content">
          <span>{{ 'inspections.machine-selector.select-template' | translate }}</span>
        </div>
      </div>
    </div>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-modal-table">
          <tr>
            <td class="margin">
              <h2>
                <span>{{ 'inspections.machine-selector.product-line' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <input type="hidden" name="productLineId" class="ir-form-set" formControlName="productLineId" />
                <div class="ir-line ir-select th-select" (click)="openProductLinesSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{
                      productLineSelectedValue ? productLineSelectedValue : ('plugins.equipment-info.select-product-line' | translate)
                    }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <tr *ngIf="!isOptimization">
            <td class="margin">
              <h2>
                <span>{{ 'inspections.machine-selector.machine' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <input type="hidden" name="categoryId" class="ir-form-set" formControlName="categoryId" />
                <div class="ir-line ir-select th-select" (click)="openModelsSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{ modelSelectedValue ? modelSelectedValue : ('plugins.equipment-info.select-machine' | translate) }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr *ngIf="!applicationSubType">
            <td class="margin-big">
              <h2>
                <span>{{ 'common.name' | translate }} *</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <validation-message
                  [validationControl]="categoriesForm.controls.name"
                  [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"
                ></validation-message>
                <input type="text" formControlName="name" placeholder="Your inspection name" class="ir-form-set" />
              </div>
            </td>
          </tr>
          <tr *ngIf="!applicationSubType">
            <td class="margin-big">
              <h2>
                <span>{{ 'machines.serial-number' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <input type="text" formControlName="serialNumber" placeholder="Your machine serial number" class="ir-form-set" />
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            [disabled]="categoriesForm.invalid"
          >
            <span>{{ 'inspections.machine-selector.next' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<modal (modalOutput)="selectModelsMenu($event)" (modalClosed)="onClose()" #modelsModal></modal>
<modal (modalOutput)="selectProductLinesMenu($event)" (modalClosed)="onProductLinesMenuClose()" #productLinesModal></modal>
